import { UpdateHeader } from "./CheckoutAggregatorEvents";
import type { CheckoutData, Timeslot } from "../../model/CheckoutData";
import type { UpdateHeaderDeliveryDateEvent, UpdateHeaderPickupDateEvent } from "../../model/CheckoutRequests";
import { findAllClickAndCollectGroupHeaders, findAllFsdGroupHeaders } from "../../model/CheckoutManipulation";
import { formatLocalDate } from "../../utils/DateUtil";
export class UpdateDeliveryDate extends UpdateHeader<UpdateHeaderDeliveryDateEvent> {
	constructor(date: Date) {
		const event = {
			eventType: "DeliveryDateSetEvent",
			value: formatLocalDate(date, "yyyy-MM-dd"),
		};

		const apply = (checkoutData: CheckoutData) => {
			if (!checkoutData) {
				return;
			}

			const fsdGroupHeader = findAllFsdGroupHeaders(checkoutData);
			fsdGroupHeader.forEach((header) => (header.deliveryDate = formatLocalDate(date, "yyyy-MM-dd")));
		};

		super(event as UpdateHeaderDeliveryDateEvent, apply, false);
	}
}
export class UpdatePickupDate extends UpdateHeader<UpdateHeaderPickupDateEvent> {
	constructor(date: Date, timeslot?: Timeslot | null | undefined) {
		const event = {
			timeslot: timeslot,
			eventType: "PickupDateSetEvent",
			value: formatLocalDate(date, "yyyy-MM-dd"),
		};

		const apply = (checkoutData: CheckoutData) => {
			if (!checkoutData) {
				return;
			}

			const clickAndCollectGroupHeaders = findAllClickAndCollectGroupHeaders(checkoutData);
			clickAndCollectGroupHeaders.forEach(
				(header) => (header.deliveryDate = formatLocalDate(date, "yyyy-MM-dd")),
			);
		};

		super(event as UpdateHeaderPickupDateEvent, apply, false);
	}
}
